const DEFAULT_ERROR_MESSAGE =
  "Fehler beim Anmelden. Bitte kontaktieren Sie Ihren Administrator.";

export const resolveLoginMessage = ({ error, response, fallback }) => {
  return (
    response?.data?.message ||
    error?.response?.data?.message ||
    fallback ||
    DEFAULT_ERROR_MESSAGE
  );
};
